import { lazy } from 'react'
import { useTranslation } from 'react-i18next'

// project imports
import MainLayout from 'layout/MainLayout'
import Loadable from 'ui-component/Loadable'
import ErrorElement from 'routes/ErrorElement'
import PlaceholderPage from 'views/PlaceholderPage'

// dashboard routing
const AIGeneration = Loadable(lazy(() => import('views/AIGeneration')))
const AssetPage = Loadable(lazy(() => import('views/Asset')))
const ContactUsPage = Loadable(lazy(() => import('views/ContactUs')))
const Dashboard = Loadable(lazy(() => import('views/Dashboard')))
const OrdersPage = Loadable(lazy(() => import('views/Orders')))
const PaymentPage = Loadable(lazy(() => import('views/Payment')))
const Profile = Loadable(lazy(() => import('views/Profile')))
const ProjectPage = Loadable(lazy(() => import('views/Project')))
const UploadPage = Loadable(lazy(() => import('views/Upload')))

const ForbiddenPage = () => {
  const { t } = useTranslation('common')

  return <PlaceholderPage message={t('noAccess')} />
}

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  errorElement: <ErrorElement />,
  children: [
    {
      path: '/',
      element: <Dashboard />,
      errorElement: <ErrorElement />,
    },
    {
      path: 'contact-us',
      element: <ContactUsPage />,
    },
    {
      path: 'orders',
      element: <OrdersPage />,
    },
    {
      path: 'payment/:id/:type',
      element: <PaymentPage />,
    },
    {
      path: 'profile',
      element: <Profile />,
    },
    {
      path: 'project/:id',
      element: <ProjectPage />,
    },
    {
      path: 'project/:id/asset/:assetId',
      element: <AssetPage />,
    },
    {
      path: 'project/:id/asset/:assetId/ai-house',
      element: <AIGeneration />,
    },
    {
      path: 'project/:id/task/:taskId/files',
      element: <UploadPage />,
    },
    {
      path: 'project/:id/upload',
      element: <UploadPage />,
    },
    {
      path: 'forbidden',
      element: <ForbiddenPage />,
    },
  ],
}

export default MainRoutes
